import React from 'react';

const FlagChip = ({ label, on, color }) => (
  <span className={`px-2 py-1 rounded border text-xs ${on
    ? `border-${color ?? "green"}-300 text-${color ?? 'green'}-700 bg-${color ?? "green"}-50`
    : 'border-gray-300 text-gray-500 bg-gray-50'
    }`}
  >
    {on ? '✔' : '✖'} {label}
  </span>
);

const DisplayValue = ({ value }) => {
  if (value === null || value === undefined || value === '' || value === 'N/A') {
    return <span className="italic text-gray-500 font-normal">N/A</span>;
  }
  return <span className="font-semibold text-gray-800">{value}</span>;
};

const InfoItem = ({ label, children }) => (
  <p className="flex justify-between">
    <strong>{label}:</strong>
    <span className="text-right">{children}</span>
  </p>
);


const TributacaoCard = ({ cClassTrib, ncmLinks, assessment, listcClassTrib, setcClassTrib }) => {

  if (!cClassTrib) {
    return (
      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mt-2">
        <h3 className="text-xl font-bold mb-6">Detalhes da Classificação Tributária (CBS/IBS)</h3>
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
          <p className="text-gray-600">Nenhuma informação de classificação tributária encontrada para este NCM.</p>
        </div>
      </section>
    );
  }

  const pRedIbs = cClassTrib?.p_red_ibs ?? 0;
  const pRedCbs = cClassTrib?.p_red_cbs ?? 0;

  const docItems = [
    { label: 'NF-e', value: cClassTrib?.ind_nfe },
    { label: 'NFC-e', value: cClassTrib?.ind_nfce },
    { label: 'CT-e', value: cClassTrib?.ind_cte },
    { label: 'CT-e OS', value: cClassTrib?.ind_cte_os },
    { label: 'BP-e', value: cClassTrib?.ind_bpe },
    { label: 'BP-e TA', value: cClassTrib?.ind_bpe_ta },
    { label: 'BP-e TM', value: cClassTrib?.ind_bpe_tm },
    { label: 'NF3-e', value: cClassTrib?.ind_nf3e },
    { label: 'NFS-e', value: cClassTrib?.ind_nfse },
    { label: 'NFS-e (via)', value: cClassTrib?.ind_nfse_via },
    { label: 'NFCom', value: cClassTrib?.ind_nfcom },
    { label: 'NFAgro', value: cClassTrib?.ind_nfag },
    { label: 'NFGas', value: cClassTrib?.ind_nfgas },
    { label: 'De-RE', value: cClassTrib?.ind_dere },
  ];

  const ruleItems = [
    { label: 'GIBSCBS', value: cClassTrib?.cst_ind_gibscbs },
    { label: 'GIBSCBS Mono', value: cClassTrib?.cst_ind_gibscbs_mono },
    { label: 'Redutor', value: cClassTrib?.cst_ind_gred },
    { label: 'Diferença', value: cClassTrib?.cst_ind_gdif },
    { label: 'Transf. Crédito', value: cClassTrib?.cst_ind_gtransf_cred },
    { label: 'Créd. Pres. ZFM', value: cClassTrib?.cst_ind_gcred_pres_ibszfm },
    { label: 'Ajuste Compet.', value: cClassTrib?.cst_ind_gajuste_compet },
  ];

  const techItems = [
    { label: 'Trib. Regular', value: cClassTrib?.ind_gtribregular },
    { label: 'Créd. Pres. Oper.', value: cClassTrib?.ind_gcred_pres_oper },
    { label: 'Mono Padrão', value: cClassTrib?.ind_gmono_padrao },
    { label: 'Mono Retenção', value: cClassTrib?.ind_gmono_reten },
    { label: 'Mono Ret.', value: cClassTrib?.ind_gmono_ret },
    { label: 'Mono Dif.', value: cClassTrib?.ind_gmono_dif },
    { label: 'Gestão Crédito', value: cClassTrib?.ind_gestorno_cred },
  ];

  const getColor = () => {
    switch (assessment) {
      case "Tributado integralmente":
        return "border-blue-200 bg-blue-50"
      case "Tributacao Monofasica":
        return "border-orange-200 bg-orange-50"
      default:
        return "border-emerald-200 bg-emerald-50"
    }
  }

  const getColorText = (percentage) => {
    switch (assessment) {
      case "Tributado integralmente":
        return "text-blue-900" + (percentage ? "/80" : "")
      case "Tributacao Monofasica":
        return "text-orange-500" + (percentage ? "/80" : "")
      default:
        return "text-emerald-900" + (percentage ? "/80" : "")
    }
  }

  return (
    <>
      {listcClassTrib?.length > 1 ?
        <div className="bg-white  rounded-lg shadow-sm border border-gray-200 p-4 mb-6 flex flex-row gap-2 overflow-x-auto">
          {listcClassTrib?.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                setcClassTrib(item)
              }}
              className={`w-full max-w-64 text-left rounded-lg border p-2 transition-all duration-200
                ${cClassTrib?.cclasstrib === item?.cclasstrib
                  ? "border-yellow-300 bg-yellow-50"
                  : "border-gray-200 bg-gray-50 hover:bg-gray-100"
                }`}
            >
              <div className="flex justify-between items-center">
                <span className={`font-mono text-sm ${cClassTrib?.cclasstrib === item?.cclasstrib ? 'font-bold text-yellow-800' : 'font-medium text-gray-800'}`}>
                  {item?.lcp214_anexo}
                </span>
              </div>
              <p className={`text-xs ${cClassTrib?.cclasstrib === item?.cclasstrib ? 'text-yellow-700' : 'text-gray-600'}`}>{item?.cclasstrib}</p>
              <p className={`text-[11px] ${cClassTrib?.cclasstrib === item?.cclasstrib ? 'text-yellow-700' : 'text-gray-600'}`}
                dangerouslySetInnerHTML={{ __html: item?.nome_cclasstrib }} />
            </button>
          ))}
        </div> : null}
      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="space-y-4">
          <div class="flex items-center justify-between">
            <div>
              <h2 class="text-lg font-semibold tracking-tight">Detalhes da Classificação Tributária (CBS/IBS)</h2>
              <p class="text-xs text-gray-500">Resultado baseado na planilha fornecida pela sefaz e anexos da lei complementar 214/25.</p>
            </div>
          </div>
          <div class={`mt-4 rounded-xl ${getColor()} p-4`}>
            <div class={`text-lg font-bold ${getColorText()}`}>
              {cClassTrib?.cst_descricao}
            </div>
            <div class={`mt-2 text-xs  ${getColorText(true)}`}>
              <span class="text-base font-semibold">
                cClassTrib: <b class="font-mono">{cClassTrib?.cclasstrib}</b>
              </span>
              <p class="mt-1">{cClassTrib?.nome_cclasstrib}</p>
            </div>
          </div>
          <div class="mt-4 rounded-xl border border-emerald-200 bg-emerald-50 p-4">
            <div class="text-sm font-semibold text-emerald-900">
              {cClassTrib?.lcp214_anexo ? `${cClassTrib.lcp214_anexo} - ` : ''} {cClassTrib?.nome_cclasstrib}
            </div>
            <div class="mt-1 text-xs text-emerald-900/80">
              {cClassTrib?.descricao_anexo || <DisplayValue value={null} />}
            </div>
            <div class="mt-2 text-xs text-emerald-900/80">
              Redução IBS: <b>{pRedIbs}%</b> &nbsp;•&nbsp; Redução CBS: <b>{pRedCbs}%</b>
            </div>
            <div class={"mt-2 text-xs text-emerald-900/80"}>
              Base legal: <a class="underline hover:text-emerald-800" href={cClassTrib?.link ?? "#"} target="_blank" rel="noreferrer">LC 214/2025 – Art. 125</a>
            </div>
          </div>
          <div class="mt-5 rounded-xl border border-blue-200 bg-blue-50 p-4">
            <div class="text-sm font-semibold text-blue-900">Código de Classificação</div>
            <div class="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
              <div class="bg-white rounded-lg border border-gray-200 p-3 md:col-span-2">
                <div class="text-xs text-gray-500">CST IBS/CBS</div>
                <div class="font-mono">{cClassTrib?.cst_ibs_cbs} — {cClassTrib?.descricao_cst_ibs_cbs}</div>
              </div>
              <div class="bg-white rounded-lg border border-gray-200 p-3 md:col-span-2">
                <div class="text-xs text-gray-500">Descrição (classe)</div>
                <div class="text-sm">
                  {cClassTrib?.descricao_cclasstrib}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-xs text-gray-600 p-3 bg-gray-50 rounded">
            <InfoItem label="Tipo de Alíquota">
              <DisplayValue value={cClassTrib?.tipo_aliquota} />
            </InfoItem>
            <InfoItem label="Ind. Redutor BC">
              <DisplayValue value={cClassTrib?.ind_redutor_bc} />
            </InfoItem>
            <InfoItem label="Vigência">
              <DisplayValue value={cClassTrib?.d_ini_vig} /> — <DisplayValue value={cClassTrib?.d_fim_vig} />
            </InfoItem>
            <InfoItem label="Atualização">
              <DisplayValue value={cClassTrib?.data_atualizacao} />
            </InfoItem>
          </div>
          {cClassTrib?.lc_redacao && (
            <div className="text-xs text-gray-500 p-3 bg-gray-50 rounded">
              <p><strong>Referência Legal:</strong> <span className="font-semibold text-gray-700">{cClassTrib?.lc214_25}</span></p>
              <p className="mt-1 italic text-gray-600">{cClassTrib.lc_redacao}</p>
            </div>
          )}
          <div className="mt-6">
            <h3 className="font-semibold text-gray-900 mb-3">Documentos / Indicadores</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
              {docItems.map(item => (
                <FlagChip key={item.label} color="blue" label={item.label} on={item.value === '1'} />
              ))}
            </div>
          </div>
          <div className="mt-6">
            <h4 className="font-semibold text-gray-900 mb-3">Flags técnicas (regras)</h4>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-xs">
              {[...ruleItems, ...techItems].map(item => (
                <FlagChip key={item.label} label={item.label} on={item.value === '1'} />
              ))}
            </div>
          </div>
        </div>
      </section>
      <div></div>
      <div className="bg-white rounded-xl overflow-hidden border border-neutral-200 shadow-sm mt-8">
        <div className="px-4 py-3 border-b border-neutral-200 bg-gradient-to-r from-neutral-50 to-neutral-50">
          <h4 className="text-neutral-900">Links úteis</h4>
        </div>
        <div className="p-4 space-y-3">
          <a href={ncmLinks?.capitulos_sumario ?? "#"} target='_blank' className="flex items-center p-3 border border-neutral-200 rounded-md hover:bg-neutral-50 hover:border-neutral-300">
            <i className="fa-solid fa-external-link-alt text-neutral-600 mr-3"></i>
            <div>
              <div className="text-sm text-neutral-900">Sumário de capítulos</div>
              <div className="text-xs text-neutral-500">Portal Único Siscomex</div>
            </div>
          </a>
          <a href={ncmLinks?.capitulo_nomenclatura ?? "#"} target='_blank' className="flex items-center p-3 border border-neutral-200 rounded-md hover:bg-neutral-50 hover:border-neutral-300">
            <i className="fa-solid fa-external-link-alt text-neutral-600 mr-3"></i>
            <div>
              <div className="text-sm text-neutral-900">Nomenclatura do capítulo</div>
              <div className="text-xs text-neutral-500">Portal Único Siscomex</div>
            </div>
          </a>
          <a href={cClassTrib?.link ?? "#"} target='_blank' className="flex items-center p-3 border border-neutral-200 rounded-md hover:bg-neutral-50 hover:border-neutral-300">
            <i className="fa-solid fa-external-link-alt text-neutral-600 mr-3"></i>
            <div>
              <div className="text-sm text-neutral-900">Lei Complementar 214/25</div>
              <div className="text-xs text-neutral-500">Planalto - Art. 125</div>
            </div>
          </a>
        </div>
      </div>
    </>
  );
};

export default TributacaoCard;